import React from 'react';
import { Box, Button, Typography, Stack, Link } from '@mui/material';

const CodeBlock: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box component="pre" sx={{ p: 2, bgcolor: '#f6f8fa', borderRadius: 1, overflow: 'auto' }}>
    <Box component="code" sx={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace' }}>
      {children}
    </Box>
  </Box>
);

export default function Gitleaks() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color: '#003366', mb: 2 }}>
        Gitleaks Secret Scanning
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        Gitleaks helps detect hardcoded secrets (passwords, API keys, tokens, private keys) in the working tree and Git history.
        We integrated pre-commit scanning, CI enforcement, and documentation.
      </Typography>

      <Stack spacing={2} sx={{ mb: 3 }}>
        <Typography variant="h6">Quick Commands</Typography>
        <CodeBlock>{`npm run scan:secrets
npm run scan:secrets:repo
bash .husky/tools/run-gitleaks.sh`}</CodeBlock>
        <Typography variant="body2">Reports are written to <code>reports/</code>.</Typography>
      </Stack>

      <Stack spacing={2} sx={{ mb: 3 }}>
        <Typography variant="h6">Docs</Typography>
        <Link href="/security/docs?doc=SECURITY-GITLEAKS.md&back=/security/gitleaks" underline="hover">SECURITY-GITLEAKS.md</Link>
        <Link href="https://github.com/gitleaks/gitleaks" target="_blank" rel="noreferrer" underline="hover">Gitleaks on GitHub</Link>
      </Stack>

      <Stack spacing={2}>
        <Typography variant="h6">Automation</Typography>
        <Typography variant="body2">Pre-commit: <code>.husky/pre-commit</code></Typography>
        <Typography variant="body2">CI: <code>.github/workflows/gitleaks.yml</code></Typography>
        <Button variant="contained" color="primary" href="/security/docs?doc=SECURITY-GITLEAKS.md&back=/security/gitleaks" sx={{ width: 'fit-content' }}>
          Read Implementation Guide
        </Button>
      </Stack>
    </Box>
  );
}
